import { JBaseApi } from '../base';
import { OF } from '../../util';
import {
    PagingResults,
    ApiWrapper,
    MediaLibraryList,
    GetUnclassifiedFilesParams,
    MediaLibraryStats,
    MediaLibraryFolderStats,
    Orders,
    Filters,
    MediaLibraryFilesStats,
    MoveMediaLibraryFileParams,
} from '../../types';

export class JMediaLibraryApi extends JBaseApi {
    public GetUnclassifiedFiles(
        params: GetUnclassifiedFilesParams,
    ): Promise<ApiWrapper<PagingResults<MediaLibraryList>>> {
        return this.network.post({
            o: 'objectListMediaLibrary',
            f: 'GetUnclassifiedFiles',
            format: params.format,
            page: params.page ?? 1,
            limit: params.limit,
            nolimit: params.nolimit,
        } as OF);
    }

    public getAccess(): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'mediaLibrary',
            f: 'access',
        });
    }

    public getFoldersStatsList(
        filters: Filters = [],
        orders: Orders = [],
        page = 1,
    ): Promise<ApiWrapper<PagingResults<MediaLibraryFolderStats>>> {
        return this.network.post({
            o: 'objectListMediaLibrary',
            f: 'FoldersStatsList',
            filters,
            orders,
            page,
        } as OF);
    }

    public getFilesStatsList(
        filters: Filters = [],
        orders: Orders = [],
        page = 1,
    ): Promise<ApiWrapper<PagingResults<MediaLibraryFilesStats>>> {
        return this.network.post({
            o: 'objectListMediaLibrary',
            f: 'FilesStatsList',
            filters,
            orders,
            page,
        } as OF);
    }

    public getStats(): Promise<ApiWrapper<MediaLibraryStats>> {
        return this.network.post({
            o: 'mediaLibrary',
            f: 'moderatorStats',
        } as OF);
    }

    public readFolder(uri: string): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'mediaLibrary',
            f: 'readFolder',
            uri,
        } as OF);
    }

    public readFile(uri: string): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'mediaLibrary',
            f: 'readFile',
            uri,
        } as OF);
    }

    public moveFile(params: MoveMediaLibraryFileParams): Promise<ApiWrapper<MediaLibraryList>> {
        return this.network.post({
            format: 'raw-list',
            uri: params.uriFile,
            mediaLibraryFolderOrientedLinks: params.uriFolder,
            publishTo: params.publishTo,
            o: 'article',
            f: 'update',
        } as OF);
    }
}
